import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

// ant-design
import Antd from 'ant-design-vue'
import "ant-design-vue/dist/antd.less"

// font
import "./assets/fonts/avenir/fonts.css"

// markdown
import 'github-markdown-css/github-markdown.css'

Vue.config.productionTip = false;

Vue.use(Antd)

//全局属性$message
import { message} from 'ant-design-vue'
Vue.prototype.$message = message;
message.config({
    top:`50px`, // 到页面顶部距离
    maxCount: 1 // 最大显示数, 超过限制时，最早的消息会被自动关闭
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
